
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import { Client, IJobSearchResultModel, JobSearchResultModel, ServiceTypeModel } from '@/services/api.service';
  import { Status, JobType, EnumModel, StatusEnums, JobTypeEnums } from '@/common/enumerations';
  import toStatusFormatter from '@/filters/status.formatter';
  import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
  import * as StringUtils from '@/utilities/string.utils';
  import toDateFormatter from '@/filters/todate.formatter';
  @Component({
    filters: {
      toStatus: toStatusFormatter,
      toJobItemType: toJobItemTypeFormatter,
      toDate: toDateFormatter
    }
  })
  export default class JobSearch extends Vue {
    public searchCriteria: string = '';
    public searchResults: JobSearchResultModel[] = [];

    public jobType: number = -1; // JobItemTypeEnums | null = null;
    public status: number = -1; // | null = null;

    public availableJobTypes: EnumModel[] = [];
    public availableStatusTypes: EnumModel[] = [];

    public isSearching: boolean = false;

    protected mounted() {
      console.log('Search mounted');
      const pickJobTypeModel: EnumModel = new EnumModel('(Any Project Type)', -1);
      this.availableJobTypes.push(
        ...JobTypeEnums.sort((n1, n2) => {
          return StringUtils.stringCompare(n1.name || '', n2.name || '');
        })
      );
      this.availableJobTypes.unshift(pickJobTypeModel);

      const pickAnyActiveStatusModel: EnumModel = new EnumModel('(Any Active Status)', -1);
      const pickAnyStatusModel: EnumModel = new EnumModel('(Any Status)', -2);

      this.availableStatusTypes.push(...StatusEnums);
      this.availableStatusTypes.unshift(pickAnyStatusModel);
      this.availableStatusTypes.unshift(pickAnyActiveStatusModel);

      let executeSearch: boolean = false;
      const q: string = this.$route.query.q as string;
      if (q !== null && q !== undefined) {
        this.searchCriteria = q as string;
        executeSearch = true;
      }

      const status: string = this.$route.query.status as string;
      if (status !== null && status !== undefined) {
        this.status = parseInt(status as string, 10);
        executeSearch = true;
      }

      const jobtype: string = this.$route.query.jobtype as string;
      if (jobtype !== null && jobtype !== undefined) {
        this.jobType = parseInt(jobtype as string, 10);
        executeSearch = true;
      }
      // We execute the search on mounted if we
      // have parsed up any useful parameters
      if (executeSearch) {
        this.searchJobs(true);
      }
    }

    private searchJobs(bypassHistoryPush: boolean) {
      // Setup the router history first
      // const q = this.searchCriteria;
      let searchJobType: string | undefined;
      let searchStatus: string | undefined;
      if (this.jobType > -1) {
        searchJobType = this.jobType.toString();
      }
      if (this.status !== -2) {
        searchStatus = this.status.toString();
      }
      if (!bypassHistoryPush) {
        // Make sure that we have a new route, and aren't just pushing
        // the same old route query data onto the history, as that
        // gives some issues like navigation duplicated errors
        if (
          !this.isQueryObjectMatch(this.$route.query, {
            q: this.searchCriteria,
            status: searchStatus,
            jobtype: searchJobType
          })
        ) {
          console.log('Search pushing history:', {
            q: this.searchCriteria,
            status: searchStatus,
            jobtype: searchJobType
          });
          this.$router.push({
            path: 'jobs',
            query: { q: this.searchCriteria, status: searchStatus, jobtype: searchJobType }
          });
          // If we are pushing the history, then by pushing it,
          // it will remount the view, which in turn will execute
          // the search. So we can bail out here and not continue
          // to execute the search as the mounted method will do so
          return;
        }
      }

      // @ts-ignore
      this.$Progress.start();

      this.searchResults = [];
      this.isSearching = true;
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
      console.log('Searching...');
      clientService.searchJobs(this.searchCriteria, searchJobType, searchStatus).then(data => {
        if (data !== null && data.length > 0) {
          // push the results into the list
          this.searchResults = data;
          console.log(this.searchResults);
        } else {
          // Pop some toast
          // @ts-ignore
          this.$awn.info('No matching jobs were found');
        }
        this.isSearching = false;
        // @ts-ignore
        this.$Progress.finish();
      });
    }

    private isQueryObjectMatch(currentQuery: any, newQuery: any) {
      if (currentQuery !== null && currentQuery !== undefined) {
        if (currentQuery.q !== newQuery.q) {
          return false;
        }
        if (currentQuery.status !== newQuery.status) {
          return false;
        }
        if (currentQuery.jobtype !== newQuery.jobtype) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    }
    private getLocation(job: JobSearchResultModel): string {
      return job.suburb!;
    }

    private getStatus(value: number) {
      return toStatusFormatter(value).toLowerCase();
    }
    private getJobItemType(value: number) {
      return toJobItemTypeFormatter(value, undefined).toLowerCase();
    }
  }
